import { render, staticRenderFns } from "./MagicLinkPre.vue?vue&type=template&id=54ce3dd4&scoped=true&"
import script from "./MagicLinkPre.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPre.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPre.vue?vue&type=style&index=0&id=54ce3dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce3dd4",
  null
  
)

component.options.__file = "MagicLinkPre.vue"
export default component.exports